require('./css/style.css');
require('./js/btns.js');

console.log('webpack up. 2');